import { createSlice } from "@reduxjs/toolkit";

type ListState = {
  quoteList: any;
  customerQuoteList: any;
};

const normalizeListPayload = (payload: any) => {
  if (Array.isArray(payload)) {
    return { data: payload, total: payload.length };
  }
  if (payload && typeof payload === "object") {
    return payload;
  }
  return { data: [], total: 0 };
};

const initialState: ListState = {
  quoteList: { data: [], total: 0 },
  customerQuoteList: { data: { sessions: [] }, total: 0 },
};

const quoteSlice = createSlice({
  name: "quoteSlice",
  initialState,
  reducers: {
    quoteList(state, action) {
      state.quoteList = normalizeListPayload(action.payload);
    },
    customerQuoteList(state, action) {
      state.customerQuoteList = normalizeListPayload(action.payload);
    },
  },
});

export const { quoteList, customerQuoteList } = quoteSlice.actions;
export default quoteSlice.reducer;
